<template>
  <div>
    <div class="container-body-reset-totp">
      <div class="text-left">
        <div class="mb-1 font-weight-medium">
          Enter your phone number
        </div>
        <phone-number-input
            v-model="phoneNumber"
            v-on:validate="updatePhoneValid"
        >
        </phone-number-input>
      </div>
      <v-btn
          class="primary-btn btn-next no-border mt-6"
          height="40"
          depressed
          :loading="loading"
          @click="nextStep"
          :disabled="!phoneValid"
      >
        Next
      </v-btn>
    </div>

    <div class="mt-6 error--text error-container">
      {{errorMessage}}
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import PhoneNumberInput from "@/components/PhoneNumberInput";
import defaultDataProvider from "@/services/identity-authen/defaultDataProvider";
import loginService from "@/services/identity-authen/loginService";
import resetTotpService from "@/services/resetTotpService";

export default Vue.extend({
  name: "EnterPhoneNumber",
  components: {
    PhoneNumberInput,
  },
  data() {
    const self = this;
    return {
      loading: false,
      self,
      phoneValid: false,
      phoneNumber: '',
      errorMessage: ''
    }
  },
  created() {
    if (resetTotpService.resetTotpData.phone) {
      this.phoneNumber = resetTotpService.resetTotpData.phone;
    }
  },
  methods: {
    async nextStep() {
      const prepareRes = loginService.getPrepareLoginResponse();
      const dataProvider = defaultDataProvider();
      try {
        this.loading = true;
        const res = await dataProvider.execute('RequestResetTotp', {
          'ctx.domain_id': prepareRes.user_info.domain_id,
          body: {
            data: this.phoneNumber,
            force_new_session: true,
            login_name: prepareRes.user_info.email
          }
        });
        if (res.ok) {
          resetTotpService.resetTotpData = {
            request_id: res.obj.request_id,
            token: res.obj.token,
            phone: this.phoneNumber,
            message: res.obj.message
          };
          this.$router.push({ name: 'reset-totp-enter-otp' })
        }
      } catch (e) {
        this.errorMessage = e.message
      } finally {
        this.loading = false;
      }
    },
    updatePhoneValid(value) {
      this.phoneValid = value.data;
    },
  }
})
</script>

<style lang="scss" scoped>
.container-body-reset-totp {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;

  .btn-next {
    width: 100%;
  }

  .phone-number-input {
    .v-input__control {
      .v-input__slot {
        min-height: auto;
        .v-input__prepend-inner {
          margin-top: 0px;
          display: flex;
          align-items: center;
          height: 100%;
        }
        .v-text-field__prefix {
          color: #AFAFB7;
        }
        fieldset {
          border: 2px solid #94949E;
          border-radius: 4px;

          &:focus {
            border-color: #96d3ff !important;
          }
        }
      }
    }
  }
}

.notifi-container {
  margin-top: 24px;
}
.error-container {
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
}
</style>